/**
 * @module api-web:jsgzt
 * @description 拒收工作台相关接口
 * @description
 */
import service from '@/service'

// 列表查询接口
export function getList(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/getList',
    method: 'post',
    data
  })
}

// 导出
export function exportData(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/export',
    method: 'post',
    data
  })
}

// 详情
export function info(id) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 编辑
export function update(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/update',
    method: 'post',
    data
  })
}

// 保存并提交
export function saveAndSubmit(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/saveAndSubmit',
    method: 'post',
    data
  })
}

// 确定
export function confirm(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/confirm',
    method: 'post',
    data
  })
}

// 提交
export function submit(data) {
  // 兼容旧详情页单 id 和新版工作台批量 idList，统一发送最新 DTO。
  const { id, idList, ...rest } = data
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/submit',
    method: 'post',
    data: { ...rest, idList: idList || (id == null ? [] : [id]) }
  })
}

// 驳回到wms系统
export function rejectWMS(data) {
  // reject 接口同样使用 idList；保留单 id 兼容旧调用方。
  const { id, idList, ...rest } = data
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/reject',
    method: 'post',
    data: { ...rest, idList: idList || (id == null ? [] : [id]) }
  })
}

// 指派
export function assigned(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/assigned',
    method: 'post',
    data
  })
}

// 开始处理
export function startProcess(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/startProcess',
    method: 'post',
    data
  })
}

// 批量更新备注，请求体为 RejectedWorkSpaceUpdateRemarkDTO。
export function batchUpdateRemark(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/batchUpdateRemark',
    method: 'post',
    data
  })
}

// 录入物流
export function enterLogistics(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/enterLogistics',
    method: 'post',
    data
  })
}

// 批量确认
export function batchConfirm(data) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/confirm',
    method: 'post',
    data
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 待办审核驳回
export function reject(data) {
  return service['api-scm']({
    url: '/public/activiti/rejectedItemsRegistry/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 撤销
export function withdraw(ids) {
  return service['api-scm']({
    url: '/scm/workspace/rejectedItemsRegistry/withdraw',
    method: 'post',
    data: { ids: [ids] }
  })
}
